import type { RefObject } from 'react';
import { usePortalDropdown } from './usePortalDropdown';

export interface IconPickerPosition {
  top: number;
  left: number;
}

export interface InterventionIconPicker<T extends HTMLElement> {
  isOpen: boolean;
  position: IconPickerPosition;
  triggerRef: RefObject<T | null>;
  panelRef: RefObject<HTMLDivElement | null>;
  toggle: () => void;
  close: () => void;
}

// Icon-picker flavour of the shared portal-dropdown behaviour; the panel
// opens below the trigger and closes on clicks outside trigger and panel.
export function useInterventionIconPicker<T extends HTMLElement>(): InterventionIconPicker<T> {
  return usePortalDropdown<T>();
}
